import script from "./InsertSymbolButton.vue?vue&type=script&setup=true&lang=js"
export * from "./InsertSymbolButton.vue?vue&type=script&setup=true&lang=js"

import "./InsertSymbolButton.vue?vue&type=style&index=0&id=8a8989d4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a8989d4"]])

export default __exports__